import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  constructor(
    private http: HttpClient,
    private message: NzMessageService,
  ) {}

  createInventory(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/inventory/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.message.create('success', `Inspection record has been added!`);
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getInventoryPaged(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/inventory/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getInventoryById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/inventory/get/${payload}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  getInventoryByFilter(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/inventory/get-one-by-filters`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  updateInventory(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/inventory/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.message.create(
              'success',
              `Inspection record has been updated!`,
            );
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  deleteInventory(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/inventory/soft-delete/${id}`)
        .subscribe({
          next: (response: any) => {
            this.message.create(
              'success',
              `Inspection record has been deleted!`,
            );
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }
}
